import { useRef, useState, useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { Col, Container, Form, Row } from "react-bootstrap";
import "./UserRegistration.css";
import useAuth from "../../hooks/useAuth";
import { useNavigate, Link } from "react-router-dom";
import useLogout from "../../hooks/useLogout";
import TopBar from "./TopBar";
import { useStateDistrict, useConsignmentTypes, useShippingModes } from "../../utils/Utilities.js";
import { useParams } from "react-router-dom"; // Import useParams from react-router-dom
const UPDATE_CUSTOMER_RATE_URL = "api/update-customer-rate";


const UpdateCustomerRate = () => {
    const { rateId } = useParams(); // Get the rateId from the URL
    const GET_Rate_URL = `api/get-customer-rate?rate_id=${rateId}`;


    const [showValidation, setShowValidation] = useState(false);

    const {
        statesList,
        districtsList,
        stateId,
        setStateId,
        district,
        setDistrict,
        loadingStates,
        loadingDistricts,
    } = useStateDistrict();


    const back = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setFranchiseName("");
    };

    const axiosPrivate = useAxiosPrivate();
    const userRef = useRef();
    const errRef = useRef();
    const { auth } = useAuth();


    // const [role, setRole] = useState("");
    const [franchiseName, setFranchiseName] = useState("");

    const [errMsg, setErrMsg] = useState("");
    const [success, setSuccess] = useState(false);

    const [selectedFranchise, setSelectedFranchise] = useState(null);
    const [franchiseDbId, setFranchiseDbId] = useState('');
    const [filteredFranchises, setFilteredFranchises] = useState([]);
    const [loading, setLoading] = useState(false);


    // Handle selection from dropdown
    const franchiseHandleSelect = (franchise) => {
        setFranchiseName(franchise.franchise_name);
        setFranchiseDbId(franchise.franchise_id);
        setSelectedFranchise(franchise);
        setFilteredFranchises([]);
    };

    const debounceRef = useRef(null);

    const handleInputChange = (e) => {
        const value = e.target.value;
        setFranchiseName(value);

        // Clear dropdown if input is empty
        if (!value.trim()) {
            setFilteredFranchises([]);
            return;
        }

        // Debounce API call
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            fetchFranchises(value);
        }, 400);
    };


    const fetchFranchises = async (searchValue) => {
        try {
            setLoading(true);

            const response = await axiosPrivate.get(
                `api/list-franchises`,
                {
                    params: {
                        // franchise_name: searchValue,
                        // franchise_code: searchValue,
                        search_text: searchValue
                    },
                }
            );

            setFilteredFranchises(response.data || []);
        } catch (error) {
            console.error("Error fetching franchises", error);
            setFilteredFranchises([]);
        } finally {
            setLoading(false);
        }
    };




    const [consignmentType, setConsignmentType] = useState("");
    const [shippingMode, setShippingMode] = useState("");


    const handleSubmit = async (e) => {
        e.preventDefault();

        try {
            const payload = {
                rate_id: rateId,
                franchise_id: auth.franchise_id,
                // franchise_id: Number(franchiseDbId),
                shipping_mode: shippingMode,
                consignment_type: consignmentType,
                // min_weight: Number(minimumWeight),
                max_weight: Number(maximumWeight),
                rate: Number(rate),
                ab_cost: Number(ab_cost),
                surcharge_perc: Number(surchargePerc),
            };

            // Optional fields
            const optionalFields = {
                state_id: stateId,
                district_id: district,
                customer_id: customerDbId,
                // customer_franchise_id: customerFranchiseID,
                customer_franchise_id: franchiseDbId,
            };

            Object.entries(optionalFields).forEach(([key, value]) => {
                if (value !== "" && value !== null && value !== undefined) {
                    payload[key] = Number.isNaN(Number(value)) ? value : Number(value);
                }
            });
            // console.log("payload =", JSON.stringify(payload, null, 2));


            await axiosPrivate.post(UPDATE_CUSTOMER_RATE_URL, payload, {
                headers: { "Content-Type": "application/json" },
                withCredentials: true,
            });

            alert("Customer Rate Updated successfully");
            // ClearSubmitedData();

        } catch (err) {
            let message = "";

            if (!err?.response) {
                message = "No Server Response";
            } else if (err.response?.status === 409) {
                message = err.response?.data.message;
            } else {
                message = "Failed!\n" + err.response?.data.message;
            }

            setErrMsg(message);

            // Clear error message after 5 seconds
            setTimeout(() => {
                setErrMsg("");
            }, 5000);
        }

    };

    const ClearSubmitedData = async (e) => {
        setFranchiseName("");
        setFranchiseDbId("");
        setShippingMode("");
        setConsignmentType("");
        // setMinimumWeight("");
        setMaximumWeight("");
        setRate("");
        setAb_cost("");
        setSurchargePerc("");
        setStateId("");
        setDistrict("");
        setCustomerType("");

    }




    const { consignmentTypes } = useConsignmentTypes();
    const { shippingModes } = useShippingModes();



    // const [minimumWeight, setMinimumWeight] = useState("");
    const [maximumWeight, setMaximumWeight] = useState("");
    const [rate, setRate] = useState("");
    const [ab_cost, setAb_cost] = useState("");
    const [surchargePerc, setSurchargePerc] = useState("");
    const [customerType, setCustomerType] = useState('');


    const handleCustomerTypeChange = (e) => {
        const selectedType = e.target.value;
        setCustomerType(selectedType);

        if (selectedType === "Common") {
            // Reset both when no customer type is selected
            setCustomerDbId("");
            setFranchiseDbId("");
            return;
        }

        if (selectedType === "Customer") {
            setFranchiseDbId("");
        }

        if (selectedType === "Franchise") {
            setCustomerDbId("");
        }
    };




    const [customerName, setCustomerName] = useState('');
    const [customerDbId, setCustomerDbId] = useState('');
    const [selectedCustomer, setSelectedCustomer] = useState(null);

    const [filteredCustomers, setFilteredCustomers] = useState([]);


    // ================= CUSTOMERS =================

    // Handle selection from customer dropdown

    const [customerLoading, setCustomerLoading] = useState(false);
    const handleCustomerSelect = (customer) => {
        setCustomerName(customer.customer_name);
        setCustomerDbId(customer.customer_id);
        setSelectedCustomer(customer);
        setFilteredCustomers([]);
    };

    const customerDebounceRef = useRef(null);

    const handleCustomerInputChange = (e) => {
        const value = e.target.value;
        setCustomerName(value);

        if (!value.trim()) {
            setFilteredCustomers([]);
            return;
        }

        if (customerDebounceRef.current) {
            clearTimeout(customerDebounceRef.current);
        }

        customerDebounceRef.current = setTimeout(() => {
            fetchCustomers(value);
        }, 400);
    };

    const fetchCustomers = async (searchValue) => {
        try {
            setCustomerLoading(true);

            const response = await axiosPrivate.get(
                `/api/list-customers?franchise_id=${auth.franchise_id}`,
                {
                    params: {
                        search_text: searchValue
                    },
                }
            );

            setFilteredCustomers(response.data || []);
        } catch (error) {
            console.error("Error fetching customers", error);
            setFilteredCustomers([]);
        } finally {
            setCustomerLoading(false);
        }
    };







    const navigate = useNavigate();
    const handleRedirect = () => {
        navigate("/list/customer_rate");
    }




    const [rateDetails, setRateDetails] = useState(null);  // To store fetched rate data
    const [error, setError] = useState(null);    // To handle errors

    useEffect(() => {
        const fetchData = async () => {
            const headers = {
                'Content-Type': 'application/json',
            };

            try {
                const response = await axiosPrivate.get(GET_Rate_URL, {
                    headers,
                    withCredentials: true, // Ensures cookies are sent with the request if needed
                });
                setRateDetails(response.data); // Store the fetched data into the setRateDetails state
                // console.log("response:", JSON.stringify(response.data, null, 2));
                setCustomerType(response.data.customer_type);

                if (response.data.customer_type === "Customer") {
                    setCustomerName(response.data.customer_name);
                    setCustomerDbId(response.data.customer_id)
                } else if (response.data.customer_type === "Franchise") {
                    setFranchiseName(response.data.customer_name);
                    setFranchiseDbId(response.data.customer_id)
                }



                setStateId(response.data.state_id)
                setDistrict(response.data.district_id)
                setShippingMode(response.data.shipping_mode)
                setConsignmentType(response.data.consignment_type)
                // setMinimumWeight(response.data.min_weight)
                setMaximumWeight(response.data.max_weight)
                setRate(response.data.rate)
                setAb_cost(response.data.ab_cost)
                setSurchargePerc(response.data.surcharge_perc)
                setLoading(false); // Stop loading spinner
            } catch (error) {
                console.error("Error fetching data:", error);
                setError("Failed to load data");
                setLoading(false);  // Set loading to false even if there is an error
            }
        };

        fetchData();
    }, [rateId]);  // Add rateId as a dependency to re-fetch data if rateId changes

    return (
        <>
            <Container>

                <section className="userregbody">
                    <p
                        ref={errRef}
                        className={errMsg ? "errmsg" : "offscreen"}
                        aria-live="assertive"

                    >
                        {errMsg}
                    </p>

                    <div className=" wrapperemp2">
                        <button onClick={() => navigate(-1)} className="btn btn-secondary newviewbtn"> ← Back</button>
                        <form onSubmit={handleSubmit}> {/* Add onSubmit handler to trigger login */}

                            <h3>Edit Customer Rate</h3>
                            <Row>


                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="shippingMode">Shipping Mode<sup>*</sup></label>
                                        <select
                                            className="form-control"
                                            value={shippingMode}
                                            required
                                            onChange={(e) => setShippingMode(e.target.value)}
                                        >
                                            <option value="">Select Shipping Mode</option>

                                            {shippingModes.map((mode) => (
                                                <option key={mode.shipping_mode} value={mode.shipping_mode}>
                                                    {mode.description}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                                <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="password">Consignment Type<sup>*</sup></label>
                                        <select
                                            className="form-control"
                                            value={consignmentType}
                                            required
                                            onChange={(e) => setConsignmentType(e.target.value)}
                                        >
                                            <option value="">Select Consignment Type</option>

                                            {consignmentTypes.map((item) => (
                                                <option
                                                    key={item.consignment_type}
                                                    value={item.consignment_type}
                                                >
                                                    {item.description}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>
                            </Row>
                            <Row>

                                {/* <Col>
                                    <div className=" input-boxs">
                                        <label htmlFor="confirm_pwd">Minimum Weight
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="minimumWeight"
                                            value={minimumWeight}
                                            required
                                            onChange={(e) => setMinimumWeight(e.target.value)}
                                        // placeholder="Minimum Weight"
                                        />

                                    </div>
                                </Col> */}
                                <Col>
                                    <div className="input-boxs">
                                        <label htmlFor="confirm_pwd">
                                            Maximum Weight
                                            <sup>*</sup>
                                        </label>

                                        <div className="weight-input-wrapper">
                                            <input
                                                type="number"
                                                name="maximumWeight"
                                                value={maximumWeight}
                                                min="0"
                                                step="0.001"
                                                onChange={(e) => setMaximumWeight(e.target.value)}
                                                required
                                            />
                                            <span>kg</span>
                                        </div>
                                    </div>
                                </Col>


                                <Col>
                                    <div className=" input-boxs">
                                        <label>Rate
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="rate"
                                            value={rate}
                                            required
                                            onChange={(e) => setRate(e.target.value)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className=" input-boxs">
                                        <label >ab cost
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="ab_cost"
                                            value={ab_cost}
                                            required
                                            onChange={(e) => setAb_cost(e.target.value)}
                                        />
                                    </div>
                                </Col>


                                <Col>
                                    <div className=" input-boxs">
                                        <label >Surcharge %
                                            <sup>*</sup></label>
                                        <input
                                            type="number"
                                            name="surchargePerc"
                                            value={surchargePerc}
                                            required
                                            onChange={(e) => setSurchargePerc(e.target.value)}
                                        />
                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>

                                    <div className="input-boxs">
                                        <label>State</label>

                                        <select
                                            className="newregselect"
                                            value={stateId}
                                            onChange={(e) => setStateId(e.target.value)}
                                        >
                                            <option value="">Select State</option>

                                            {statesList.map((state) => (
                                                <option key={state.state_id} value={state.state_id}>
                                                    {state.state_name} - ({state.state_code})
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </Col>





                                <Col>

                                    <div className="input-boxs">
                                        <label>District</label>

                                        <select
                                            className="newregselect"
                                            value={district}
                                            onChange={(e) => setDistrict(e.target.value)}
                                            disabled={!stateId}
                                        >
                                            <option value="">Select District</option>

                                            {districtsList.map((dist) => (
                                                <option key={dist.district_id} value={dist.district_id}>
                                                    {dist.district_name} - ({dist.district_code})
                                                </option>
                                            ))}
                                        </select>


                                    </div>
                                </Col>
                            </Row>
                            <Row>
                                <Col>
                                    <div className="input-boxs">
                                        <label>Customer Type</label>
                                        <select
                                            className="newregselect"
                                            value={customerType}
                                            onChange={handleCustomerTypeChange}
                                            disabled
                                            style={{
                                                ...styles.input,
                                                backgroundColor: "#f2f2f2",
                                                color: "#888",
                                                cursor: "not-allowed"
                                            }}
                                        >
                                            <option value="Common">Select Customer Type</option>
                                            <option value="Customer">Individual Customer</option>
                                            <option value="Franchise">Franchise Customer</option>
                                        </select>
                                    </div>
                                </Col>


                                {customerType === "Customer" && (
                                    <Col>
                                        <div className="input-boxs">
                                            <label htmlFor="CustomerName">
                                                Customer Name or Address
                                            </label>

                                            <input
                                                type="text"
                                                id="customer-name"
                                                autoComplete="off"
                                                placeholder="Search Customer Name or Address"
                                                onChange={handleCustomerInputChange}
                                                value={customerName}

                                                style={styles.input}
                                            />

                                            {customerLoading && <div className="loader">Searching...</div>}

                                            {customerName && filteredCustomers.length > 0 && (
                                                <ul style={styles.dropdown}>
                                                    {filteredCustomers.map((customer) => (
                                                        <li
                                                            key={customer.customer_id}
                                                            style={styles.dropdownItem}
                                                            onMouseDown={() => handleCustomerSelect(customer)}
                                                        >
                                                            {customer.customer_name} - {customer.customer_address1}
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>
                                    </Col>


                                )}

                                {customerType === "Franchise" && (
                                    <Col>
                                        <div className="input-boxs">
                                            <label htmlFor="FranchiseName">
                                                Franchise Name or Code <sup>*</sup>
                                            </label>

                                            <input
                                                type="text"
                                                id="franchise-name"
                                                autoComplete="off"
                                                placeholder="Search Franchise Name or Code"
                                                onChange={handleInputChange}
                                                value={franchiseName}
                                                style={styles.input}
                                            />

                                            {loading && <div className="loader">Searching...</div>}

                                            {franchiseName && filteredFranchises.length > 0 && (
                                                <ul style={styles.dropdown}>
                                                    {filteredFranchises.map((franchise) => (
                                                        <li
                                                            key={franchise.franchise_id}
                                                            style={styles.dropdownItem}
                                                            onMouseDown={() => franchiseHandleSelect(franchise)}
                                                        >
                                                            {franchise.franchise_name} ({franchise.franchise_code})
                                                        </li>
                                                    ))}
                                                </ul>
                                            )}
                                        </div>

                                    </Col>
                                )}


                            </Row>
                            <center>
                                <button type="submit" className="btn regbutton">Submit</button>
                            </center>
                        </form>
                    </div>
                </section>

                <TopBar />
            </Container>
        </>
    );
};

const styles = {
    container: {
        padding: '40px',
        maxWidth: '500px',
        margin: 'auto',
        fontFamily: 'Arial, sans-serif',
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
        gap: '20px',
    },
    inputWrapper: {
        display: 'flex',
        flexDirection: 'column',
    },
    input: {
        padding: '10px',
        fontSize: '16px',
        border: '1px solid #ccc',
        borderRadius: '4px',
    },
    dropdown: {
        position: 'absolute',
        top: '100%',
        left: 0,
        right: 0,
        zIndex: 1000,
        backgroundColor: '#fff',
        border: '1px solid #ccc',
        borderTop: 'none',
        maxHeight: '200px',
        overflowY: 'auto',
        listStyle: 'none',
        padding: 0,
        margin: 0,
        boxShadow: '0px 2px 6px rgba(0,0,0,0.15)',
    },
    dropdownItem: {
        padding: '10px',
        cursor: 'pointer',
        borderBottom: '1px solid #eee',
    },
    button: {
        padding: '10px 15px',
        backgroundColor: '#007bff',
        color: '#fff',
        border: 'none',
        borderRadius: '4px',
        fontSize: '16px',
        cursor: 'pointer',
    },


};

export default UpdateCustomerRate;
